import { render, staticRenderFns } from "./urgentTime.vue?vue&type=template&id=60b3e1aa&scoped=true&"
import script from "./urgentTime.vue?vue&type=script&lang=js&"
export * from "./urgentTime.vue?vue&type=script&lang=js&"
import style0 from "./urgentTime.vue?vue&type=style&index=0&id=60b3e1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3e1aa",
  null
  
)

export default component.exports